import type { Placement } from "@floating-ui/react-dom";
import type { ReactNode } from "react";
import { Suspense } from "..";
import { CollaborationEnabledProvider } from "./CollaborationEnabledProvider";

const CHART_LOCK_ID = [
  "DCfXEeEoQWs3YjQnjher",
  "vlw73Zw30AXpPhGeiCJP",
  "Ej0iK5g1agUPEqS6UKWz",
];

export const BlockFeatureCollaborationProvider = ({
  children,
  id,
  tooltip,
  placement = "bottom-end",
  maxWidth = 160,
  isSettings = false,
}: {
  children: ReactNode;
  id: string;
  tooltip: string;
  placement?: Placement;
  maxWidth?: number;
  isSettings?: boolean;
}) => {
  return (
    <CollaborationEnabledProvider fallback={children}>
      <Suspense feature="Collaboration feature lock">
        <Content
          id={id}
          tooltip={tooltip}
          placement={placement}
          maxWidth={maxWidth}
          isSettings={isSettings}
        >
          {children}
        </Content>
      </Suspense>
    </CollaborationEnabledProvider>
  );
};

const Content = ({
  children,
  id,
  placement,
  tooltip,
  maxWidth,
  isSettings = false,
}: {
  children: ReactNode;
  id: string;
  placement: Placement;
  tooltip: string;
  maxWidth: number;
  isSettings?: boolean;
}) => {
  if (CHART_LOCK_ID.includes(id)) id = "mv2VL2QbFsmLliHpu3Jj";

  // const userOnFeature = useStorage((state) => {
  //   const features = state.activeFeatures as Record<string, User>;
  //   return features?.[id];
  // });

  return <>{children}</>;
  // if (!userOnFeature) return <>{children}</>;
  // return (
  //   <SettingsWrapper isSettings={isSettings}>
  //     <Tooltip
  //       tooltip={getTooltip(userOnFeature.name, tooltip)}
  //       hideArrow
  //       placement={placement}
  //       maxWidth={maxWidth}
  //       className="tw-text-center"
  //     >
  //       <div className="tw-relative tw-cursor-not-allowed after:tw-absolute after:tw-inset-0 after:tw-block after:tw-size-full after:tw-cursor-not-allowed after:tw-bg-white after:tw-opacity-40 after:tw-content-['']">
  //         {children}
  //       </div>
  //     </Tooltip>
  //   </SettingsWrapper>
  // );
};

const getTooltip = (name: string, tooltip: string) => {
  return tooltip.replace("[name]", name);
};

const SettingsWrapper = ({
  children,
  isSettings = false,
}: {
  children: ReactNode;
  isSettings?: boolean;
}) => {
  if (!isSettings) return <>{children}</>;
  return (
    <div className="tw-relative tw-mx-[6px] after:tw-absolute after:tw-right-[-6px] after:tw-top-1/2 after:tw-h-4 after:tw-w-[1px] after:-tw-translate-y-1/2 after:tw-bg-[#e4e3e9] after:tw-content-[''] first:tw-ml-0 last:tw-mr-0 last:after:tw-hidden">
      {children}
    </div>
  );
};
